/* Andrea Nicole — Pet Illustrated deposit pricing (native, no app).
   Keeps the native add-to-cart + photo upload untouched.
   Populates line-item properties (Full price, Balance due, hidden balance link),
   shows the deposit disclosure prominently at the price (above the fold on mobile).
   Values are driven by the maps below so they stay correct BEFORE and AFTER the
   go-live price flip to £39. All DOM writes are idempotent (only-if-changed) so the
   MutationObserver cannot loop. */
(function () {
  var DEPOSIT = 39;

  // portrait variant id -> real full price (also the ORIGINAL prices = reversibility record)
  var FULL = {
    "56232609677652": 129.95, "56232609710420": 159.95, "56232609743188": 164.95,
    "56232609775956": 194.95, "56232609808724": 164.95, "56232609841492": 194.95,
    "56232609874260": 164.95, "56232609907028": 194.95, "56232609939796": 139.95,
    "56232609972564": 169.95, "56232610005332": 191.95, "56232610038100": 221.95,
    "56232610070868": 191.95, "56232610103636": 221.95, "56232610136404": 191.95,
    "56232610169172": 221.95, "56232610201940": 152.95, "56232610234708": 182.95,
    "56232610267476": 225.95, "56232610300244": 255.95, "56232610333012": 225.95,
    "56232610365780": 255.95, "56232610398548": 225.95, "56232610431316": 255.95
  };

  // portrait variant id -> balance checkout permalink (balance = full - 39)
  var LINK = {
    "56232609677652": "/cart/56390789661012:1", "56232609710420": "/cart/56390789759316:1",
    "56232609743188": "/cart/56390789792084:1", "56232609775956": "/cart/56390789923156:1",
    "56232609808724": "/cart/56390789792084:1", "56232609841492": "/cart/56390789923156:1",
    "56232609874260": "/cart/56390789792084:1", "56232609907028": "/cart/56390789923156:1",
    "56232609939796": "/cart/56390789693780:1", "56232609972564": "/cart/56390789824852:1",
    "56232610005332": "/cart/56390789890388:1", "56232610038100": "/cart/56390789955924:1",
    "56232610070868": "/cart/56390789890388:1", "56232610103636": "/cart/56390789955924:1",
    "56232610136404": "/cart/56390789890388:1", "56232610169172": "/cart/56390789955924:1",
    "56232610201940": "/cart/56390789726548:1", "56232610234708": "/cart/56390789857620:1",
    "56232610267476": "/cart/56390789988692:1", "56232610300244": "/cart/56390790021460:1",
    "56232610333012": "/cart/56390789988692:1", "56232610365780": "/cart/56390790021460:1",
    "56232610398548": "/cart/56390789988692:1", "56232610431316": "/cart/56390790021460:1"
  };

  function money(n) { return "£" + Number(n).toFixed(2); }

  function scopeEl() {
    var c = document.querySelector(".an-deposit-callout");
    return (c && c.closest(".product, [id^=MainProduct], section")) || document;
  }

  function currentVariantId() {
    var input = scopeEl().querySelector('.product-variant-id, input[name="id"]');
    return input ? String(input.value || "").trim() : null;
  }

  function setText(el, val) { if (el && el.textContent !== val) el.textContent = val; }

  function update() {
    var scope = scopeEl();
    var id = currentVariantId();
    if (!id || !FULL[id]) return;
    var full = FULL[id];
    var balance = Math.round((full - DEPOSIT) * 100) / 100;
    var link = LINK[id] || "";

    // line-item property inputs (value set does not mutate observed DOM)
    var fp = scope.querySelector(".an-dep-full"); if (fp) fp.value = money(full);
    var bp = scope.querySelector(".an-dep-balance"); if (bp) bp.value = money(balance);
    var lp = scope.querySelector(".an-dep-link"); if (lp) lp.value = link;

    // lower callout amounts
    setText(scope.querySelector(".an-dep-full-text"), money(full));
    setText(scope.querySelector(".an-dep-balance-text"), money(balance));

    // main price -> "£39 deposit today" (set once per rendered element instance)
    var priceEl = scope.querySelector(".price .price-item--regular");
    if (priceEl && priceEl.dataset.anDeposit !== "1") {
      priceEl.innerHTML = money(DEPOSIT) + ' <span style="font-size:.6em;opacity:.7;font-weight:400">deposit today</span>';
      priceEl.dataset.anDeposit = "1";
    }

    // prominent disclosure immediately after the price (above the fold on mobile)
    var priceBox = scope.querySelector(".price");
    if (priceBox) {
      var note = scope.querySelector(".an-deposit-price-note");
      if (!note) {
        note = document.createElement("div");
        note.className = "an-deposit-price-note";
        note.style.cssText = "margin-top:8px;font-size:1.5rem;line-height:1.45";
        priceBox.insertAdjacentElement("afterend", note);
      }
      if (note.dataset.forVariant !== id) {
        note.innerHTML =
          '<strong>(balance ' + money(balance) + ' payable on your approval)</strong>' +
          '<br><span style="opacity:.85">Full price ' + money(full) +
          '. Hand-drawn from your photo by a real UK artist.</span>';
        note.dataset.forVariant = id;
      }
    }

    // sticky add-to-cart bar (#sticky-atc): keep it COMPACT.
    // price -> "£39 deposit"; balance as one small line INSIDE the info column
    // (not beside the button), so the bar stays a tight 3-line block.
    // Both this and the theme's own sticky JS write here; idempotent + only-if-changed
    // means they converge without looping.
    var stickyPrice = document.querySelector(".sticky-atc__price--current");
    if (stickyPrice) {
      var wantPrice = money(DEPOSIT) + " deposit";
      if (stickyPrice.textContent !== wantPrice) stickyPrice.textContent = wantPrice;
    }
    var stickyInfo = document.querySelector("#sticky-atc .sticky-atc__product-info");
    if (stickyInfo) {
      var sBal = stickyInfo.querySelector(".an-sticky-balance");
      if (!sBal) {
        sBal = document.createElement("p");
        sBal.className = "an-sticky-balance";
        stickyInfo.appendChild(sBal);
      }
      var wantBal = "balance " + money(balance) + " on approval";
      if (sBal.textContent !== wantBal) sBal.textContent = wantBal;
    }
  }

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms || 60); };
  }

  function init() {
    update();
    var dUpdate = debounce(update, 60);
    document.addEventListener("change", function (e) {
      if (e.target.closest && e.target.closest(".product-form, variant-selects, fieldset")) dUpdate();
    });
    var scope = scopeEl();
    if (scope && scope !== document && window.MutationObserver) {
      new MutationObserver(dUpdate).observe(scope, { childList: true, subtree: true });
    }
    // the sticky bar lives outside the product section and refreshes its own price
    var sticky = document.querySelector("#sticky-atc");
    if (sticky && window.MutationObserver) {
      new MutationObserver(dUpdate).observe(sticky, { childList: true, subtree: true, characterData: true });
    }
    // guarantee fresh values the instant they add to cart
    document.addEventListener("submit", function (e) {
      if (e.target.closest && e.target.closest(".product-form, product-form")) update();
    }, true);
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest('[name="add"], .shopify-payment-button')) update();
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
